import type { ReactNode } from "react";
import { connect } from "react-redux";

import actions from "@/actions";

import Button from "../base/Button";

const renderIcon = (color: string): ReactNode => (
    <svg
        width="24px"
        height="23px"
        viewBox="0 0 24 23"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>rotate-right</title>
        <desc>Created with Sketch.</desc>
        <g
            id="Lightsmap-2.0"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="Select---Rotate"
                transform="translate(-99.000000, -137.000000)"
            >
                <g id="Group-2" transform="translate(0.000000, 130.000000)">
                    <g
                        id="img-rotate-right"
                        transform="translate(111.000000, 18.500000) scale(-1, 1) translate(-111.000000, -18.500000) translate(100.000000, 8.000000)"
                    >
                        <rect
                            id="Rectangle"
                            stroke={color}
                            strokeLinecap="square"
                            x="0"
                            y="9"
                            width="15"
                            height="12"
                        />
                        <path
                            d="M14,2 L17,2 C19.761,2 22,4.239 22,7 L22,10"
                            id="Path"
                            stroke={color}
                            strokeLinecap="square"
                        />
                        <polygon
                            id="Path"
                            stroke={color}
                            strokeLinecap="square"
                            points="14 4 11 2 14 0"
                        />
                        <polygon
                            id="Path"
                            fill="#FFFFFF"
                            fillRule="nonzero"
                            points="14 4 11 2 14 0"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

interface RotateButtonProps {
    disabled: boolean;
    onClick: (...args: unknown[]) => unknown;
}

const RotateButton = (props: RotateButtonProps) => (
    <Button {...props} renderIcon={renderIcon} />
);

const mapStateToProps = ({ map }: { map: any }) => ({
    disabled:
        map.general.mode.name !== "view" &&
        map.general.selectedLights.length <= 0 &&
        map.general.selectedMarkers.length <= 0,
});

const mapDispatchToProps = {
    onClick: actions.map.values.mode.rotateLights,
};

export default connect(mapStateToProps, mapDispatchToProps)(RotateButton);
